import axios from "../../config/axiosConfig";
import { CREATE_GRADE, GET_GRADE, GRADE_REQUEST, DELETE_GRADE, UPDATE_GRADE, GRADE_REQUEST_FAILURE } from "../types";
import { addMasterInOption, updateMasterInOption } from "./master-options-actions";

export const getGrades = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRADE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/grade/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_GRADE, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRADE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRADE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createGrade = (grade) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: GRADE_REQUEST });
      return axios.post("/grade/add", grade,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
          if (response.data) {
            dispatch({ type: CREATE_GRADE, payload: response.data });
            dispatch(addMasterInOption('grades', response.data));
          } else {
            dispatch({
              type: GRADE_REQUEST_FAILURE,
              error: "Grade create failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: GRADE_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRADE_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
      throw error;
    }
  };
};

export const updateGrade = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRADE_REQUEST });
      const { auth } = getState();
      return axios.put("/grade/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_GRADE,
            payload: { id, data: response.data },
          });
          dispatch(updateMasterInOption('grades', id, response.data));
        } else {
          dispatch({
            type: GRADE_REQUEST_FAILURE,
            error: "Grade update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRADE_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRADE_REQUEST_FAILURE, error: error?.response?.data?.error || error.message });
      throw error;
    }
  };
};

export const deleteGrade = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GRADE_REQUEST });
      return axios.delete(`/grade/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_GRADE, id: id });
          dispatch(updateMasterInOption('grades', id));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRADE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRADE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
